import { z } from 'zod';

export const accountSubtypes = [
  'ServiceAccount',
  'SharedMailbox',
  'SharedSignIn',
  'AppRegistration',
  'Other',
] as const;

// EntraCloud is sync-owned; manual entry uses the other three.
export const accountSources = ['Manual', 'OnPremAD', 'Other'] as const;

const guidRe = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export const accountSchema = z.object({
  DisplayName: z.string().trim().min(1, 'Display name is required'),
  Subtype: z.enum(accountSubtypes),
  Source: z.enum(accountSources),
  UPN: z.string().trim().optional(),
  EntraObjectId: z
    .string()
    .trim()
    .optional()
    .refine((v) => !v || guidRe.test(v), 'Entra object ID must be a GUID'),
  OwnerPersonId: z.number().int().positive().nullable().optional(),
  Purpose: z.string().trim().optional(),
  Notes: z.string().trim().optional(),
  Active: z.boolean(),
});

export type AccountFormData = z.infer<typeof accountSchema>;
